export default {"src":"/_next/static/media/matching.d4b13136.svg","height":40,"width":40};